import async from '../components/Async';
import { PERMISSIONS } from '../constants';

const Users = async(() => import('../views/Users'));
const Organizations = async(() => import('../views/Organizations'));
const OrganizationDetails = async(() => import('../views/OrganizationDetails'));
const GroupDetails = async(() => import('../views/CustomerGroupDetails'));
const Roles = async(() => import('../views/Roles'));
const Permissions = async(() => import('../views/Permissions'));
const Versions = async(() => import('../views/Versions'));
const Server = async(() => import('../views/Server'));
const Profile = async(() => import('../views/Profile'));
const UserDetails = async(() => import('../views/UserDetails'));
const CreateUser = async(() => import('../views/CreateUser'));
const CreateRole = async(() => import('../views/CreateRole'));
const RoleDetails = async(() => import('../views/RoleDetails'));
const CreatePermission = async(() => import('../views/CreatePermission'));
const PermissionDetails = async(() =>
  import('../components/PermissionDetails')
);
const CreateOrganization = async(() => import('../views/CreateOrganization'));
const CreateGroup = async(() => import('../views/CreateCustomerGroup'));
const Home = async(() => import('../views/Home'));

export const navbarRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/organizations',
    name: 'Organizations',
    component: Organizations,
    permissions: [PERMISSIONS.ORGANIZATION_READ],
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    permissions: [PERMISSIONS.USER_READ],
  },
  {
    path: '/roles',
    name: 'Roles',
    component: Roles,
    permissions: [PERMISSIONS.ROLE_READ],
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: Permissions,
    permissions: [PERMISSIONS.PERMISSION_READ],
  },
  {
    path: '/versions',
    name: 'Versions',
    component: Versions,
    permissions: [PERMISSIONS.VERSION_WRITE],
  },
  {
    path: '/server',
    name: 'Server',
    component: Server,
    permissions: [PERMISSIONS.CACHE_DELETE],
  },
];

export const routes = [
  {
    path: '/organizations/create',
    component: CreateOrganization,
    permissions: [PERMISSIONS.ORGANIZATION_CREATE],
  },
  {
    path: '/organizations/:id/create',
    component: CreateGroup,
    permissions: [PERMISSIONS.GROUP_CREATE],
  },
  {
    path: ['/organizations/:id'],
    component: OrganizationDetails,
    permissions: [PERMISSIONS.ORGANIZATION_READ],
  },
  {
    path: ['/groups/:id'],
    component: GroupDetails,
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/roles/create',
    component: CreateRole,
    permissions: [PERMISSIONS.ROLE_CREATE],
  },
  {
    path: '/roles/:id',
    component: RoleDetails,
    permissions: [PERMISSIONS.ROLE_READ],
  },
  {
    path: '/users/create',
    component: CreateUser,
  },
  {
    path: '/users/:id',
    component: UserDetails,
  },
  {
    path: '/permissions/create',
    component: CreatePermission,
    permissions: [PERMISSIONS.PERMISSION_CREATE],
  },
  {
    path: '/permissions/:id',
    component: PermissionDetails,
    permissions: [PERMISSIONS.PERMISSION_READ],
  },
  ...navbarRoutes,
];
